import UserCard from './UserCard';
import ProductCard from'./ProductCard';
import TaggedContentCard from './TaggedContentCard';
import FlippingCard from './FlippingCard';
import FlippingCardFront from './FlippingCard/FlippingCardFront';
import FlippingCardBack from './FlippingCard/FlippingCardBack';
import PaymentCard from './PaymentCard';
import RecipeCard from './RecipeCard';
import NewsHeaderCard from './NewsHeaderCard';
import CryptoCard from './CryptoCard';
import DropdownCard from './DropdownCard';

export default {
  UserCard,
  ProductCard,
  TaggedContentCard,
  FlippingCard,
  FlippingCardFront,
  FlippingCardBack,
  PaymentCard,
  RecipeCard,
  NewsHeaderCard,
  CryptoCard,
  DropdownCard
};

export {
  UserCard,
  ProductCard,
  TaggedContentCard,
  FlippingCard,
  FlippingCardFront,
  FlippingCardBack,
  PaymentCard,
  RecipeCard,
  NewsHeaderCard,
  CryptoCard,
  DropdownCard
};
